module.exports = __webpack_public_path__ + "img/icon-wechat.c1d67ea1.svg";